var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0E90D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65812 5.655C9.72983 5.58329 9.80155 5.58329 9.87326 5.655L10.4541 6.23587C10.5258 6.30758 10.5258 6.3793 10.4541 6.45101L8.94817 7.95697C8.91948 7.98566 8.91948 8.01434 8.94817 8.04303L10.4541 9.54899C10.5258 9.6207 10.5258 9.69242 10.4541 9.76413L9.87326 10.345C9.80155 10.4167 9.72983 10.4167 9.65812 10.345L8.15216 8.83904C8.12347 8.81035 8.09479 8.81035 8.0661 8.83904L6.56014 10.345C6.48843 10.4167 6.41671 10.4167 6.345 10.345L5.76413 9.76413C5.69242 9.69242 5.69242 9.6207 5.76413 9.54899L7.27009 8.04303C7.29878 8.01434 7.29878 7.98566 7.27009 7.95697L5.76413 6.45101C5.69242 6.3793 5.69242 6.30758 5.76413 6.23587L6.345 5.655C6.41671 5.58329 6.48843 5.58329 6.56014 5.655L8.0661 7.16096C8.09479 7.18965 8.12347 7.18965 8.15216 7.16096L9.65812 5.655Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DeleteIcon.9923502f.svg";
export { ForwardRef as ReactComponent };